import React, { useState } from 'react';
import I18n from 'i18n-js';

import { RCIcon, RCPopover, RCText, RCButton } from '@reverbdotcom/cadence/components';
import { MapPinLineIcon, TagIcon, LockIcon } from '@reverbdotcom/cadence/icons/react';
import SanitizedRender from './sanitized_render';
import CoreLink from './core_link';
import { useHelpCenterArticleUrl } from '../url_helpers';


const ACCESS_POINTS_HELP_CENTER_ARTICLE_ID = '53752523634971';

export default function AccessPointPickupCallout({ showMapPinIcon = false }: { showMapPinIcon?: boolean }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <span className="fg-color-text-primary">
      <RCPopover
        isOpen={isOpen}
        onDismiss={() => setIsOpen(false)}
        anchor={
          <RCButton
            variant="link"
            size="small"
            onClick={() => setIsOpen(!isOpen)}
            leadingIcon={showMapPinIcon ? <MapPinLineIcon /> : undefined}
          >
            <RCText.Utility size="350">
              {I18n.t('commons.accessPointCallout.pickUpNearby')}
            </RCText.Utility>
          </RCButton>
        }
      >
        <div className="d-flex gap-2 fx-dir-col">
          <div>
            <RCIcon icon={<MapPinLineIcon />} size="inline" spacing="right" />
            {I18n.t('commons.accessPointCallout.shipToUpsStores')}
            <CoreLink
              to={useHelpCenterArticleUrl(ACCESS_POINTS_HELP_CENTER_ARTICLE_ID)}
            >
              {I18n.t('commons.accessPointCallout.learnMore')}
            </CoreLink>
          </div>
          <div>
            <RCIcon icon={<TagIcon />} size="inline" spacing="right" />
            <SanitizedRender
              html={I18n.t('commons.accessPointCallout.saveOnShippingCosts',
                {
                  tagOpen: '<strong>',
                  tagClose: '</strong>',
                },
              )}
            />
          </div>
          <div>
            <RCIcon icon={<LockIcon />} size="inline" spacing="right" />
            {I18n.t('commons.accessPointCallout.keepGearSafe')}
          </div>
        </div>
      </RCPopover>
      <span className="text-utility-350">
        {I18n.t('commons.accessPointCallout.saveOnShipping')}
      </span>
    </span>
  );
}
